module.exports = __webpack_public_path__ + "9dc1645eff19f1e7518f5ad208070be6.fbx";